import React from "react";
import { Navigate } from "react-router-dom";
import authStorage from 'providers/authStorage.js';

const GuestRoute = ({ allowRegistered, element }) => {
    if (!allowRegistered && authStorage.getAccess()) {
        return <Navigate to="/404" replace />;
    }
    return element;
};

export default GuestRoute;